import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { IExamState } from "../hoc/stdLiveWrapper";
import { useQuery } from "react-query";
import { developAxios } from "../../axios.config";
import downloadIcon from "../Assets/Images/download.svg";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend);

export default function DownloadData({
	setSubmittedUsers,
	// unSubmittedCount,
	setEnrolledStudents,
}: IExamState) {
	// const [isLoading, setIsLoading] = useState(false);
	const [disableExportButton, setDisableExportButton] = useState(false);
	const [pie, setPie] = useState<{
		labels: Array<string>;
		datasets: Array<{
			label: string;
			data: Array<number>;
			backgroundColor: Array<string>;
		}>;
	}>();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);

	const { _id: id } = useParams<{ _id: string }>();

	const style = {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginTop: "30px",
	};
	const card = {
		height: "300px",
		width: "80%",
		border: "1px solid",
		borderRadius: "10px",
		display: "flex",
		justifyContent: "space-evenly",
		alignItems: "center",
	};

	useQuery(
		["get-submitted-exam-results", id],
		() => {
			let exam_type = queryParams.get("type") === "coding";
			return developAxios(localStorage.getItem("token") || "").get<{
				length: number;
			}>(
				exam_type
					? `/getCompilerTestResultsByExam/${id}`
					: `/getSubmittedUsersByExamId_quiz/${id}`
			);
		},
		{
			refetchInterval: 20000,
			onSuccess: ({ data }) => {
				if (queryParams.get("type") === "coding") {
					setSubmittedUsers && setSubmittedUsers(data.length);
				}
			},
		}
	);

	useEffect(() => {
		developAxios(localStorage.getItem("token") || "")
			.get(
				`/live-exams/get-live-students/${id}?type=${queryParams.get(
					"type"
				)}`
			)
			.then(({ data }) => {
				setEnrolledStudents &&
					setEnrolledStudents(data.totalStudentsWhoEnrolled);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	useEffect(() => {
		function getType(val: string) {
			switch (val) {
				case "eightyToOneHundred":
					return "80% - 100%";

				case "sixtyToEighty":
					return "60% - 80%";

				case "thirtyToSixty":
					return "30% - 60%";

				default:
					return "0% - 30%";
			}
		}

		function getColor(val: string) {
			switch (val) {
				case "eightyToOneHundred":
					return "#FF6384";

				case "sixtyToEighty":
					return "#F1AF13";

				case "thirtyToSixty":
					return "#62B170";

				default:
					return "#E97D30";
			}
		}

		developAxios(localStorage.getItem("token") || "")
			.get(
				`/live-exams/get-exam-heat-map/${id}?type=${queryParams.get(
					"type"
				)}`
			)
			.then(({ data }) => {
				let labels: Array<string> = [];
				let num_data: Array<number> = [];
				let bg_color: Array<string> = [];
				Object.keys(data).forEach((val) => {
					console.log(val);
					labels.push(getType(val));
					num_data.push(parseFloat(data[val]));
					bg_color.push(getColor(val));
				});

				const pieChartData = {
					labels,
					datasets: [
						{
							label: "# of vote",
							data: num_data,
							backgroundColor: bg_color,
						},
					],
				};
				setPie(pieChartData);
			})
			.catch((e) => {
				console.error(e);
			});
	}, []);

	function downloadFile(tab: number) {
		const type = tab === 2 ? "submitted" : "unsubmitted";
		const examType = queryParams.get("type");

		setDisableExportButton(true);
		fetch(
			`${process.env.REACT_APP_BASE_URL}/${
				tab === 2
					? examType === "coding"
						? `downloadCompilerTestResultsByExam`
						: `downloadSubmittedUsersByExamId_quiz`
					: examType === "coding"
					? `downloadUnSubmittedUsers`
					: `downloadUnSubmittedUsersByExamId_quiz`
			}/${id}`,
			{
				headers: {
					Authorization: `Bearer ${
						localStorage.getItem("token") || ""
					}`,
				},
			}
		)
			.then((res) => res.blob())
			.then((blob) => {
				const url = window.URL.createObjectURL(new Blob([blob]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", `${type}_${id}_file.xlsx`);
				document.body.appendChild(link);
				link.click();
			})
			.catch((err) => {
				alert(`Unable to download file ${type}_${id}_file.xlsx`);
			})
			.finally(() => setDisableExportButton(false));
	}

	return (
		<div className="downloadData">
			<div className="downloadBtn mt-3">
				<div className="submittedBtn">
					<button
						id="buttn"
						className="flex bg-[#1ad598] w-full py-2 px-3 rounded items-center text-white"
						onClick={() => downloadFile(2)}
						disabled={disableExportButton}
					>
						Submitted data{" "}
						<span>
							<img
								width={25}
								height={25}
								className="downloadIcon ml-2"
								src={downloadIcon}
								alt=""
							/>
						</span>
					</button>
				</div>
				<div className="unsubmitedBtn">
					<button
						className="flex bg-[#db5aee] w-full py-2 px-3 rounded items-center text-white"
						onClick={() => downloadFile(3)}
						disabled={disableExportButton}
					>
						Unsubmitted data{" "}
						<span>
							<img
								width={25}
								height={25}
								className="downloadIcon ml-2"
								src={downloadIcon}
								alt=""
							/>
						</span>
					</button>
				</div>
			</div>

			<div style={style}>
				<div style={card} className="pie-charts">
					{" "}
					{pie && (
						<Pie
							data={pie}
							options={{
								maintainAspectRatio: false,
								responsive: true,
							}}
						/>
					)}
				</div>
			</div>
		</div>
	);
}

DownloadData.defaultProps = {
	setSubmittedUsers: (count: number) => {},
	setEnrolledStudents: (count: number) => {},
};
